import adminApiClient from './adminApiClient';

const adminSettingsService = {
  /** Load all platform settings as a key-value object. */
  getSettings: () => adminApiClient.get('/api/admin/settings'),

  /** Save settings (key-value object). */
  saveSettings: (settings) => adminApiClient.put('/api/admin/settings', settings),

  /**
   * Send a test email.
   * @param {Object} smtpConfig - { host, port, username, password, encryption, toEmail }
   * @returns {Promise<{ success: boolean, message: string }>}
   */
  sendTestEmail: (smtpConfig) =>
    adminApiClient.post('/api/admin/settings/test-email', smtpConfig),
};

export default adminSettingsService;
